import { Modal, ModalBody } from "reactstrap";
import BasicDataTable from "../../Component/BasicComponents/BasicDataTable";
import { FaEye, FaEdit } from "react-icons/fa";
import { useEffect, useState } from "react";
import RouteModal from "../../Component/BasicComponents/Modal/RouteModal";
import OnboardingAddressModalContent from "./ModalContent/OnboardingAddressModalContent";
import { useSingleAddressData } from "./hooks/useOnBoard";
import GlobalShimmer from "../../utils/GlobalShimmer";
import { sendMediaIds } from "./hooks/OnBoardingRepo";
import pdf from "../../assets/images/pdf_image.png";

const OnboardingRequestLogDataColumns = (
  handleEditAddress: (row: any) => void,
  handleViewClick: (row: any) => void,
  EDMDetailsData: any
) => [
  {
    name: "Type",
    selector: (row: { OutletSubTypeName: string }) =>
      row.OutletSubTypeName || "-",
    sortable: true,
    wrap: true,
    width: "160px",
  },

  {
    name: "Address",
    selector: (row: { Address: string }) => row?.Address || "-",
    sortable: true,
    width: "160px",
    wrap: true,
  },

  {
    name: "Landmark",
    selector: (row: { Landmark: string }) => row?.Landmark || "-",
    sortable: true,
    width: "160px",
    wrap: true,
  },
  {
    name: "Town",
    selector: (row: { TownName: string }) => row?.TownName || "-",
    sortable: true,
    width: "160px",
    wrap: true,
  },
  {
    name: "PinCode",
    selector: (row: { Pincode: string }) => row?.Pincode || "-",
    sortable: true,
    width: "160px",
    wrap: true,
  },

  {
    name: "City",
    selector: (row: { CityName: string }) => row?.CityName || "-",
    sortable: true,
    wrap: true,
    width: "160px",
  },

  {
    name: "State",
    selector: (row: { StateName: string }) => row?.StateName || "-",
    sortable: true,
    wrap: true,
    width: "160px",
  },
  {
    name: "Patches",
    selector: (row: { BeatName: string }) => row?.BeatName || "-",
    sortable: true,
    wrap: true,
    width: "160px",
  },
  {
    name: "Visit Frequency",
    selector: (row: { VisitFrequency: string }) => row?.VisitFrequency || "-",
    sortable: true,
    wrap: true,
    width: "180px",
  },
  {
    name: "Classification",
    selector: (row: { Speciality: string }) => row.Speciality || "-",
    sortable: true,
    wrap: true,
    width: "160px",
  },
  {
    name: "Potential",
    selector: (row: { Potential: string }) => row?.Potential || "-",
    sortable: true,
    wrap: true,
    width: "160px",
  },
  // {
  //   name: "Attachments",
  //   width: "160px",
  //   wrap: true,
  //   cell: (row: any) => (
  //     <div className="d-flex align-items-center gap-2">
  //       <button
  //         className="btn d-flex align-items-center justify-content-center gap-1"
  //         onClick={() => handleViewClick(row)}
  //         style={{
  //           backgroundColor: "#2e8dd3",
  //           color: "white",
  //           borderRadius: "20px",
  //           padding: "3px",
  //           width: "70px",
  //           border: "none",
  //         }}
  //       >
  //         <FaEye size={14} style={{ fill: "#fff" }} /> View
  //       </button>
  //     </div>
  //   ),
  // },
  {
    name: "Attachments",
    width: "160px",
    wrap: true,
    cell: (row: any) => {
      const hasDocs =
        row?.SpportDocuments && row.SpportDocuments.trim().length > 0;
      return hasDocs ? (
        <button
          className="btn d-flex align-items-center justify-content-center gap-1"
          onClick={() => handleViewClick(row)}
          style={{
            backgroundColor: "#2e8dd3",
            color: "white",
            borderRadius: "20px",
            padding: "3px",
            width: "70px",
            border: "none",
          }}
        >
          <FaEye size={14} style={{ fill: "#fff" }} /> View
        </button>
      ) : (
        <button
          className="btn d-flex align-items-center justify-content-center gap-1"
          style={{
            backgroundColor: "grey",
            color: "white",
            borderRadius: "20px",
            padding: "3px",
            width: "70px",
            border: "none",
          }}
          disabled={true}
        >
          <FaEye size={14} style={{ fill: "#fff" }} /> View
        </button>
      );
    },
  },

  {
    name: "Action",
    width: "130px",
    cell: (row: any) =>
      EDMDetailsData?.data?.Status === "Executed" ||
      EDMDetailsData?.data?.Status === "Final Approved" ? (
        <button
          className="btn btn-primary d-flex align-items-center justify-content-center gap-1"
          style={{
            borderRadius: "20px",
            padding: "3px",
            width: "70px",
            backgroundColor: "grey",
            borderColor: "grey",
            color: "#ffffff",
          }}
          disabled={
            EDMDetailsData?.data?.Status === "Executed" ||
            EDMDetailsData?.data?.Status === "Final Approved"
          }
        >
          <FaEdit size={14} style={{ fill: "#fff" }} /> Edit
        </button>
      ) : (
        <button
          onClick={() => handleEditAddress(row)}
          className="btn btn-primary d-flex align-items-center justify-content-center gap-1"
          style={{ borderRadius: "20px", padding: "3px", width: "70px" }}
        >
          <FaEdit size={14} style={{ fill: "#fff" }} /> Edit
        </button>
      ),
  },
];

const OnboardingAddress = ({
  addressListData,
  setFilterAddressState,
  EDMDetailsData,
}: {
  addressListData: any;
  setFilterAddressState: any;
  EDMDetailsData?: any;
}) => {
  const [isImageOpen, setIsImageOpen] = useState(false);
  const [isEditOpen, setIsEditOpen] = useState(false);
  const [addressID, setAddressID] = useState("");
  const [orgUnitIds, setOrgUnitIds] = useState("");
  const [selectedRowData, setSelectedRowData] = useState<any>(null);
  const [imageLoading, setImageLoading] = useState(false);
  const [attachmentMediaData, setAttachmentMediaData] = useState([]);

  // console.log(
  //   "🚀 ~ OnboardingAddress.tsx:214 ~ OnboardingAddress ~ attachmentMediaData:",
  //   attachmentMediaData
  // );

  const toggleImageModal = () => setIsImageOpen(!isImageOpen);
  const toggleEditModal = () => setIsEditOpen(!isEditOpen);

  const handleEditAddress = (row: any) => {
    setIsEditOpen(true);
    setAddressID(row?.OnBoardRequestAddressId);
    setOrgUnitIds(row?.OrgUnitId);
    setSelectedRowData(row);
  };
  const handleViewClick = async (row: any) => {
    const mediaIds = row?.SpportDocuments.split(",");
    const response = await sendMediaIds(mediaIds);
    const attachmentData = response?.data;
    setAttachmentMediaData(attachmentData);
    if (attachmentData.length > 0) {
      setIsImageOpen(true);
      setImageLoading(true);
      setAttachmentMediaData(attachmentData);
      setAddressID(row?.OnBoardRequestAddressId);
    } else {
      setIsImageOpen(true);
      setImageLoading(true);
    }
  };
  const handlePagination = (pageNo: number) => {
    setFilterAddressState((prevState: any) => {
      return {
        ...prevState,
        start: pageNo,
      };
    });
  };
  const handleonChangeRowsPerPage = (limit: any, pageNo: any) => {
    setFilterAddressState((prevState: any) => {
      return {
        ...prevState,
        start: pageNo,
        length: limit,
      };
    });
  };

  const { data: onBoardSingleAddress } = useSingleAddressData({
    id: addressID,
    enable: !!addressID,
  });

  const BASE_URL = "https://tspc-development.truesales.in/media?id=";
  const imagesArray =
    onBoardSingleAddress?.data?.SpportDocuments?.split(",").filter(Boolean) ||
    [];

  console.log(
    "🚀 ~ OnboardingAddress.tsx:255 ~ OnboardingAddress ~ imagesArray:",
    addressListData?.data?.data?.SpportDocuments
  );

  useEffect(() => {
    if (imagesArray?.length > 0) {
      const response = sendMediaIds(imagesArray);
      console.log(
        "🚀 ~ OnboardingAddress.tsx:257 ~ OnboardingAddress ~ response:",
        response
      );
    } else {
      return;
    }
  }, [onBoardSingleAddress]);

  return (
    <div>
      <BasicDataTable
        Title="Addresses"
        columns={OnboardingRequestLogDataColumns(
          handleEditAddress,
          handleViewClick,
          EDMDetailsData
        )}
        data={addressListData?.data?.data || []}
        onChangePage={(pageNo: number) => {
          handlePagination(pageNo);
        }}
        onChangeRowsPerPage={(newPerPage: any, page: any) => {
          handleonChangeRowsPerPage(newPerPage, page);
        }}
        paginationTotalRows={addressListData?.data?.recordsTotal || 0}
        search={false}
      />

      <Modal
        isOpen={isImageOpen}
        toggle={toggleImageModal}
        centered
        backdrop={true}
        size={imagesArray.length > 2 ? "xl" : "md"} // ✔️ Adjust modal size based on image count
        className="d-flex justify-content-center align-items-center"
      >
        <ModalBody
          onClick={toggleImageModal}
          style={{
            padding: "20px",
            backgroundColor: "#fff",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            maxHeight: "600px",
            overflowY: "auto", // ✔️ enable vertical scroll if needed
            borderRadius: "20px",
          }}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              display: "flex",
              flexWrap: "wrap",
              justifyContent: "center",
              alignItems: "center",
              gap: "20px",
              width: "100%",
            }}
          >
            {attachmentMediaData.map((doc: any, index) => {
              const fileUrl = `${BASE_URL}${doc.MediaId}`;
              const isImage = doc.MediaMime.startsWith("image/");
              const isPdf = doc.MediaMime === "application/pdf";

              return (
                <div
                  key={index}
                  style={{
                    width: "300px",
                    flexShrink: 0,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    flexDirection: "column",
                  }}
                >
                  {isImage && (
                    <>
                      {imageLoading && (
                        <GlobalShimmer width="100%" height="300px" />
                      )}
                      <img
                        src={fileUrl}
                        alt={doc.MediaName}
                        style={{
                          width: "100%",
                          height: "auto",
                          maxHeight: "300px",
                          objectFit: "contain",
                          borderRadius: "8px",
                          boxShadow: "0 4px 15px rgba(0, 0, 0, 0.2)",
                          display: imageLoading ? "none" : "block",
                        }}
                        onLoad={() => setImageLoading(false)}
                        onError={() => setImageLoading(false)}
                      />
                    </>
                  )}

                  {isPdf && (
                    <>
                      {imageLoading && (
                        <GlobalShimmer width="100%" height="300px" />
                      )}
                      <img
                        src={pdf}
                        alt={doc.MediaName}
                        style={{
                          width: "100%",
                          height: "auto",
                          maxHeight: "280px",
                          objectFit: "contain",
                          borderRadius: "8px",
                          boxShadow: "0 4px 15px rgba(0, 0, 0, 0.2)",
                          display: imageLoading ? "none" : "block",
                          cursor: "pointer",
                        }}
                        onClick={() => window.open(fileUrl, "_blank")}
                      />

                      <p style={{ marginTop: "10px", fontSize: "14px" }}>
                        {doc.MediaName}
                      </p>
                      {/* <button
                        className="btn btn-primary mt-2"
                        style={{ borderRadius: "20px", padding: "5px 15px" }}
                        onClick={() => window.open(fileUrl, "_blank")}
                      >
                        View PDF
                      </button> */}
                    </>
                  )}
                </div>
              );
            })}

            {attachmentMediaData.length === 0 && !imageLoading && (
              <img
                src="https://via.placeholder.com/300x300?text=No+File"
                alt="no-file"
                style={{
                  width: "300px",
                  height: "auto",
                  objectFit: "contain",
                  borderRadius: "8px",
                  boxShadow: "0 4px 15px rgba(0, 0, 0, 0.2)",
                }}
              />
            )}
          </div>
        </ModalBody>
      </Modal>

      <RouteModal
        isOpen={isEditOpen}
        toggle={toggleEditModal}
        title={"Edit Address"}
        size="lg"
        content={
          <OnboardingAddressModalContent
            orgUnitIds={orgUnitIds}
            EDMDetailsData={EDMDetailsData}
            selectedRowData={selectedRowData}
            setIsEditOpen={setIsEditOpen}
            singleAddress={onBoardSingleAddress?.data}
          />
        }
      />
    </div>
  );
};

export default OnboardingAddress;
